import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import { useForm, SubmitHandler, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useAuth } from "hooks/useAuth";
import {useServerErrors} from "hooks/useServerErrors";
import FormField from "shared/form/FormField";
import ErrorsList from "shared/ui/ErrorsList";
import { APIPostForgotPassword } from "../api/passwordReset";
import {APIGetSchoolsLogin} from "../api/schools";

export interface IFormForgotPassword {
    domain: {label: string, value: number, slug: string};
    email: string;
}

const schema = yup
    .object({})
    .required();

const ForgotPasswordForm = ({type} : {type: "school" | "teacher"}) => {
    const {update} = useAuth();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<string>("");

    const methods = useForm<IFormForgotPassword>({
        resolver: yupResolver(schema),
    });
    const { handleServerErrors } = useServerErrors<IFormForgotPassword>(methods.setError);

    const handleResetPasswordError = (err: any) => {
        if (err?.response?.status === 400) {
            const errors = err.response.data.data;
            handleServerErrors(errors);
            if (errors.general) {
                methods.setError("email", {type: "server", message: errors.general[0]});
            }
            if(errors.value) {
                setErrorMessage(err.response.data.data.value);
            }
        } else {
            update("error", {show: true, code: "A001"});
        }
    };
    const onSubmit: SubmitHandler<IFormForgotPassword> = (data) => {
        const domain = type === "school" ? (data.domain?.slug || null) : "teachers";

        update("loading", {show: true, modal: true});
        APIPostForgotPassword({
            domain: domain,
            email: data.email,
        })
            .then((response) => {
                if (response.data.success) {
                    methods.clearErrors();
                    methods.reset({email: ""});

                    update("error", {
                        show: true,
                        message: response.data.data.value,
                        title: "",
                        icon: "fat envelope",
                        closable: true,
                        button: "ÎNCHIDE",
                        returnFunction: () => navigate("/"),
                    });
                } else {
                    update("error", {show: true, code: "A002"});
                }
            })
            .catch(handleResetPasswordError)
            .finally(() =>  update("loading", {show: false}));
    };

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
                {type === "school" &&
                    <Box py={1}>
                        <FormField
                            name="domain"
                            type="autocomplete_api"
                            label="Tastează numele școlii"
                            optionsAPI={APIGetSchoolsLogin}
                            defaultValue={null}
                            multiple={false}
                            filterOptions={(x: any) => x}
                            errorMessage={methods.formState.errors.domain?.message}
                            error={!!methods.formState.errors.domain?.message}
                            autoFocus={true}
                        />
                    </Box>
                }
                <Box py={1}>
                    <FormField
                        name="email"
                        type="text"
                        defaultValue=""
                        label="Adresa de e-mail"
                        autoComplete="email"
                        autoFocus={false}
                        errorMessage={methods.formState.errors.email?.message}
                        error={!!methods.formState.errors.email?.message}
                    />
                </Box>
                <Box sx={{mt: 1, mb: 3}}>
                    <Button type="submit" variant="contained">Trimite e-mail</Button>
                    <ErrorsList show={errorMessage !== ""}>{errorMessage}</ErrorsList>
                </Box>
            </form>
        </FormProvider>
    );
};

export default ForgotPasswordForm;
